import type { CheckerMovement } from "@/game/utils/animationTypes";
import { Constants, type GameState } from "@nextgammon/shared";

/**
 * Remove one checker from the movement source
 */
export function applyCheckerMovementStart(
  prev: GameState | null,
  movement: CheckerMovement
): GameState | null {
  const nextState = structuredClone(prev);

  if (nextState) {
    if (movement.fromPoint < Constants.HOME_BOARD_WHITE_START) {
      // Off / bar region for white
      if (movement.fromIsBar) {
        nextState.bar.white = Math.max(0, (nextState.bar.white || 0) - 1);
      } else {
        nextState.off.white = Math.max(0, (nextState.off.white || 0) - 1);
      }
    } else if (movement.fromPoint > Constants.HOME_BOARD_BLACK_END) {
      // Off / bar region for black
      if (movement.fromIsBar) {
        nextState.bar.black = Math.max(0, (nextState.bar.black || 0) - 1);
      } else {
        nextState.off.black = Math.max(0, (nextState.off.black || 0) - 1);
      }
    } else {
      const point = nextState.board[movement.fromPoint];
      if (point && point.count > 0 && point.player === movement.playerColor) {
        point.count = Math.max(0, point.count - 1);
        if (point.count === 0) {
          point.player = null;
        }
      }
    }
  }
  return nextState;
}

/**
 * Add one checker to the movement destination (including bump handling).
 */
export function applyCheckerMovementEnd(
  prev: GameState | null,
  movement: CheckerMovement
): GameState | null {
  const nextState = structuredClone(prev);

  if (nextState) {
    if (movement.toPoint < Constants.HOME_BOARD_WHITE_START) {
      if (movement.toIsBar) {
        nextState.bar.white = (nextState.bar.white || 0) + 1;
      } else {
        nextState.off.white = (nextState.off.white || 0) + 1;
      }
    } else if (movement.toPoint > Constants.HOME_BOARD_BLACK_END) {
      if (movement.toIsBar) {
        nextState.bar.black = (nextState.bar.black || 0) + 1;
      } else {
        nextState.off.black = (nextState.off.black || 0) + 1;
      }
    } else {
      const point = nextState.board[movement.toPoint];
      if (point) {
        if (point.player === null || point.player === movement.playerColor) {
          point.player = movement.playerColor;
          point.count++;
        } else {
          // Bump opponent: replace ownership, keep count at 1 (implicit capture behavior).
          point.player = movement.playerColor;
        }
      } else {
        nextState.board[movement.toPoint] = {
          player: movement.playerColor,
          count: 1
        };
      }
    }
  }
  return nextState;
}
